import React, { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { propertyFormUpdate } from "reduxStore/action/propertyActions";
import moment from "moment";
import strings from "translate/language";
import { seo, handleListResponse } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";
import {
  getConfiguration,
  getMasterList,
} from "reduxStore/action/masterActions";
import { MasterTypeHelper } from "utils/constants";
import Input from "component/Input";

const EditPropertyStepThird = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [form, setForm] = useState({});
  const { property_id = "" } = params || {};
  const [configurationsType, setConfigurationsType] = useState([]);
  const [unitType, setUnitType] = useState([]);
  const [businessDevelopment, setBusinessDevelopment] = useState({
    rera_possession: "",
    expected_possession: "",
    land_parcel: "",
    towers: "",
    typology: "",
    rera_carpet: "",
    builtup_area: "",
    saleble_area: "",
    all_inclusive: "",
    payment_scheme: "",
    tentative_closing_price: "",
    current_stage: "",
    positive: "",
    negative: "",
    upcoming_infrastructure: "",
    supports_for_cp: "",
  });

  const navigatpage = async (navname) => {
    navigate(navname);
  };
  // const [image, setImage] = useState({ preview: "", raw: "" });
  const [formState, setFormState] = useState({});

  const dispatch = useDispatch();
  const propertyFormSelector = useSelector((state) => state.propertyForm) || {};

  const configurationsSelector =
    useSelector((state) => state.configurations) || {};
  const unitTypeSelector = useSelector((state) => state.masterData) || {};
  useEffect(() => {
    if (configurationsSelector.response) {
      const { response } = configurationsSelector;
      if (response?.status === 200) {
        setConfigurationsType(handleListResponse(response.data));
      } else {
        setConfigurationsType([]);
      }
    }
  }, [configurationsSelector]);
  useEffect(() => {
    if (unitTypeSelector.response) {
      const { response } = unitTypeSelector;
      if (response?.status === 200) {
        setUnitType(handleListResponse(response.data));
      } else {
        setUnitType([]);
      }
    }
  }, [unitTypeSelector]);

  useLayoutEffect(() => {
    dispatch(getConfiguration());
    dispatch(getMasterList({ type: MasterTypeHelper.unitType }));
  }, []);

  const handleInputFieldBDS = (e) => {
    const nextBusinessDevelopmentState = {
      ...businessDevelopment,
      [e.target.name]: e.target.value,
    };
    setBusinessDevelopment(nextBusinessDevelopmentState);
  };

  useEffect(() => {
    const { response } = propertyFormSelector;
    if (response) {
      setFormState({
        ...propertyFormSelector?.response,
        land_parcel: null,
        payment_scheme: null,
        rera_carpet: null,
        builtup_area: null,
        rera_possession: moment(response?.rera_possession).format("yyyy-MM-DD"),
        expected_possession: moment(response?.expected_possession).format(
          "yyyy-MM-DD"
        ),
      });
      let typeofBDM = typeof response?.business_development_marketing;
      if (typeofBDM === "string" || typeofBDM === "object") {
        const obj =
          typeofBDM === "object"
            ? response?.business_development_marketing
            : JSON.parse(response?.business_development_marketing);
        // var o = Object.entries(obj).map(([key, value]) => {
        //   var o = {};
        //   if (isNaN(key)) {
        //     o[key] = value
        //   }
        //   return o
        // }).filter(i => !isEmpty(i))[0]
        setBusinessDevelopment(obj);
      }
    }
  }, [propertyFormSelector]);

  const handleNext = () => {
    formState.business_development_marketing = businessDevelopment;
    dispatch(propertyFormUpdate(formState));
    navigatpage("/editpropertystepfourth/" + property_id);
  };
  useEffect(() => {
    seo({
      title: "Edit Property",
      metaDescription: "edit property details",
      canonicalLink: window.location.href,
    });
  }, []);

  var tmp = [];
  for (var i = 1; i <= 10; i++) {
    tmp.push(i);
  }
  var stage = [];
  for (var i = 0; i <= 10; i++) {
    stage.push(i * 10);
  }

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.BusinessDM}
        url={"/property"}
        parentListing={strings.propertyListing}
        titleactive={strings.editProperty}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.BusinessDM}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.reraPossession}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="date"
                        placeholder={strings.reraPossession}
                        name="rera_possession"
                        value={businessDevelopment?.rera_possession}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                        min={moment().add(1, "days").format("yyyy-MM-DD")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.expectedPossession}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="date"
                        placeholder={strings.expectedPossession}
                        name="expected_possession"
                        value={businessDevelopment?.expected_possession}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                        min={moment().add(1, "days").format("yyyy-MM-DD")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.landparcel}
                      </label>
                      <div className="d-flex flex-direction-row">
                        <Input
                          disabled
                          className="form-control digits"
                          id="exampleFormControlInput1"
                          type="number"
                          autoComplete="off"
                          isNumber={true}
                          name="land_parcel"
                          value={businessDevelopment?.land_parcel?.units}
                          onChange={(e) => {
                            const nextBusinessDevelopmentState = {
                              ...businessDevelopment,
                              land_parcel: {
                                ...businessDevelopment?.land_parcel,
                                units: e.target.value,
                              },
                            };
                            setBusinessDevelopment(
                              nextBusinessDevelopmentState
                            );
                          }}
                          onKeyPress={(e) => {
                            if (e.target.value.length >= 10) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <select
                          disabled
                          id="exampleFormControlSelect9"
                          name="units"
                          value={businessDevelopment?.land_parcel?.unitType}
                          onChange={(e) => {
                            const nextBusinessDevelopmentState = {
                              ...businessDevelopment,
                              land_parcel: {
                                ...businessDevelopment?.land_parcel,
                                unitType: e.target.value,
                              },
                            };
                            setBusinessDevelopment(
                              nextBusinessDevelopmentState
                            );
                          }}
                        >
                          <option value={""}>{strings.units}</option>
                          {unitType.length > 0 ? (
                            unitType.map((item, i) => (
                              <option key={i} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option>{strings.Loading}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.towers}
                      </label>
                      <select
                        disabled
                        className="form-control digits"
                        id="formcontrol-select1"
                        name="towers"
                        value={businessDevelopment?.towers}
                        onChange={handleInputFieldBDS}
                      >
                        <option value={""}>{strings.selectTowers}</option>
                        {tmp.map((item, i) => (
                          <option key={i} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.typology}
                      </label>
                      <select
                        disabled
                        className="form-control digits"
                        id="formcontrol-select1"
                        name="typology"
                        value={businessDevelopment?.typology}
                        onChange={handleInputFieldBDS}
                      >
                        <option value={""}>
                          {strings.selectConfiguration}
                        </option>
                        {configurationsType.length > 0 ? (
                          configurationsType.map((item, i) => (
                            <option key={i} value={item._id}>
                              {item.title}
                            </option>
                          ))
                        ) : (
                          <option>{strings.Loading}</option>
                        )}
                      </select>
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.reraCarpet}
                      </label>
                      <div className="d-flex flex-direction-row">
                        <Input
                          disabled
                          className="form-control digits"
                          id="exampleFormControlInput1"
                          type="number"
                          autoComplete="off"
                          isNumber={true}
                          name="rera_carpet"
                          value={businessDevelopment?.rera_carpet?.units}
                          onChange={(e) => {
                            const nextBusinessDevelopmentState = {
                              ...businessDevelopment,
                              rera_carpet: {
                                ...businessDevelopment?.rera_carpet,
                                units: e.target.value,
                              },
                            };
                            setBusinessDevelopment(
                              nextBusinessDevelopmentState
                            );
                          }}
                          onKeyPress={(e) => {
                            if (e.target.value.length >= 10) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <select
                          disabled
                          id="exampleFormControlSelect9"
                          name="units"
                          value={businessDevelopment?.rera_carpet?.unitType}
                          onChange={(e) => {
                            const nextBusinessDevelopmentState = {
                              ...businessDevelopment,
                              rera_carpet: {
                                ...businessDevelopment?.rera_carpet,
                                unitType: e.target.value,
                              },
                            };
                            setBusinessDevelopment(
                              nextBusinessDevelopmentState
                            );
                          }}
                        >
                          <option value={""}>{strings.units}</option>
                          {unitType.length > 0 ? (
                            unitType.map((item, i) => (
                              <option key={i} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option>{strings.Loading}</option>
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.builtUpArea}
                      </label>
                      <div className="d-flex flex-direction-row">
                        <Input
                          disabled
                          className="form-control digits"
                          id="exampleFormControlInput1"
                          type="number"
                          isNumber={true}
                          autoComplete="off"
                          name="builtup_area"
                          value={businessDevelopment?.builtup_area?.units}
                          onChange={(e) => {
                            const nextBusinessDevelopmentState = {
                              ...businessDevelopment,
                              builtup_area: {
                                ...businessDevelopment?.builtup_area,
                                units: e.target.value,
                              },
                            };
                            setBusinessDevelopment(
                              nextBusinessDevelopmentState
                            );
                          }}
                          onKeyPress={(e) => {
                            if (e.target.value.length >= 10) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <select
                          disabled
                          id="exampleFormControlSelect9"
                          name="units"
                          value={businessDevelopment?.builtup_area?.unitType}
                          onChange={(e) => {
                            const nextBusinessDevelopmentState = {
                              ...businessDevelopment,
                              builtup_area: {
                                ...businessDevelopment?.builtup_area,
                                unitType: e.target.value,
                              },
                            };
                            setBusinessDevelopment(
                              nextBusinessDevelopmentState
                            );
                          }}
                        >
                          <option value={""}>{strings.units}</option>
                          {unitType.length > 0 ? (
                            unitType.map((item, i) => (
                              <option key={i} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option>{strings.Loading}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.salabelArea}
                      </label>
                      <div className="d-flex flex-direction-row">
                        <Input
                          disabled
                          className="form-control digits"
                          id="exampleFormControlInput1"
                          type="number"
                          isNumber={true}
                          autoComplete="off"
                          name="saleble_area"
                          value={businessDevelopment?.saleble_area?.units}
                          onChange={(e) => {
                            const nextBusinessDevelopmentState = {
                              ...businessDevelopment,
                              saleble_area: {
                                ...businessDevelopment?.saleble_area,
                                units: e.target.value,
                              },
                            };
                            setBusinessDevelopment(
                              nextBusinessDevelopmentState
                            );
                          }}
                          onKeyPress={(e) => {
                            if (e.target.value.length >= 10) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <select
                          disabled
                          id="exampleFormControlSelect9"
                          name="units"
                          value={businessDevelopment?.saleble_area?.unitType}
                          onChange={(e) => {
                            const nextBusinessDevelopmentState = {
                              ...businessDevelopment,
                              saleble_area: {
                                ...businessDevelopment?.saleble_area,
                                unitType: e.target.value,
                              },
                            };
                            setBusinessDevelopment(
                              nextBusinessDevelopmentState
                            );
                          }}
                        >
                          <option value={""}>{strings.units}</option>
                          {unitType.length > 0 ? (
                            unitType.map((item, i) => (
                              <option key={i} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option>{strings.Loading}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 mt-2 ">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.allInclusive}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.allInclusive}
                        name="all_inclusive"
                        value={businessDevelopment?.all_inclusive}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.paymentScheme}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.paymentScheme}
                        name="payment_scheme"
                        onChange={handleInputFieldBDS}
                        value={businessDevelopment?.payment_scheme}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2 ">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.tentativeClosingPrice}
                      </label>
                      <Input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="number"
                        isNumber={true}
                        placeholder={strings.tentativeClosingPrice}
                        name="tentative_closing_price"
                        value={businessDevelopment?.tentative_closing_price}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          if (e.target.value.length >= 10) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-2 ">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.currentStage}
                      </label>
                      <select
                        disabled
                        className="form-control digits"
                        id="formcontrol-select1"
                        name="current_stage"
                        value={businessDevelopment?.current_stage}
                        onChange={handleInputFieldBDS}
                      >
                        <option value={""}>{strings.stage}</option>
                        {stage.map((item, i) => (
                          <option key={i} value={item}>
                            {item === 0 ? "00" : item}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6 mt-2 ">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.Positive}
                      </label>
                      <textarea
                        disabled
                        name="positive"
                        placeholder={strings.Positive}
                        value={businessDevelopment?.positive}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                        className="form-control"
                        id=""
                        cols="74"
                        rows="5"
                      ></textarea>
                    </div>
                    <div className="col-md-6 mt-2 ">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.Negative}
                      </label>
                      <textarea
                        disabled
                        name="negative"
                        placeholder={strings.Negative}
                        onChange={handleInputFieldBDS}
                        value={businessDevelopment?.negative}
                        autoComplete="off"
                        className="form-control"
                        id=""
                        cols="74"
                        rows="5"
                      ></textarea>
                    </div>
                    <div className="col-md-6 mt-2 ">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.upcomingInfrastructure}
                      </label>
                      <textarea
                        disabled
                        name="upcoming_infrastructure"
                        placeholder={strings.upcomingInfrastructure}
                        value={businessDevelopment?.upcoming_infrastructure}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                        className="form-control"
                        id=""
                        cols="74"
                        rows="5"
                      ></textarea>
                    </div>
                    <div className="col-md-6 mt-2 ">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.supportsForCP}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.supportsForCP}
                        name="supports_for_cp"
                        value={businessDevelopment?.supports_for_cp}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    {/* <div className="card-footer ">
                      <Button
                        className="btn btn-color"
                        type="Button"
                        onClick={() => {
                          navigatpage("/editpropertynext/" + property_id);
                        }}
                        label={strings.back}
                      ></Button>
                    </div> */}
                    <div className="card-footer">
                      <Button
                        className="btn btn-color"
                        type="Button"
                        onClick={() => handleNext()}
                        label={strings.next}
                      ></Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditPropertyStepThird;
